import { amplitudeEventsLib } from '../amplitude-events';
import { googleAnalyticsEventsLib } from '../google-analytics-events';
import { jsBridgeEventsLib } from '../js-bridge';

export const hotOffersScroll = ({ direction }: { direction: '<' | '>' }) => {
  const mappedDirection = direction === '<' ? 'left' : 'right';
  amplitudeEventsLib.hotOffersScroll({ direction: mappedDirection });
  googleAnalyticsEventsLib.hotOffersScroll({
    direction: mappedDirection,
  });
};

export const hotOffersSearchClick = (properties: {
  origCityCode: string;
  destCityCode: string;
  date: string;
  price: string;
}) => {
  amplitudeEventsLib.hotOffersSearchClick(properties);
  googleAnalyticsEventsLib.hotOffersSearchClick(properties);
};

export const hotOffersAllDatesClick = (properties: {
  origCityCode: string;
  destCityCode: string;
}) => {
  amplitudeEventsLib.hotOffersAllDatesClick(properties);
  googleAnalyticsEventsLib.hotOffersAllDatesClick(properties);
};

export const hotOffersOriginCityChange = (properties: {
  origCityCode: string;
  source: string;
}) => {
  amplitudeEventsLib.hotOffersOriginCityChange(properties);
  googleAnalyticsEventsLib.hotOffersOriginCityChange(properties);
};

export const hotOffersPageOpen = (properties: {
  cityFrom: string;
  countryName: string;
}) => {
  amplitudeEventsLib.hotOffersPageOpen(properties);
  jsBridgeEventsLib.hotOffersPageOpened(properties);
};
